import { Component, HostBinding, Inject, Input, Optional } from "@angular/core";
import { WIDTH, HEIGHT, ROTATION } from "../icon-tokens";

@Component({
  selector: "arrow-svg",
  templateUrl: "./arrow.component.svg",
  styleUrls: ["./arrow.component.scss"],
})
export class ArrowSvgComponent {

  constructor(
    @Inject(WIDTH) @Optional() private injectedWidth: number,
    @Inject(HEIGHT) @Optional() private injectedHeight: number,
    @Inject(ROTATION) @Optional() private injectedRotation: number) { }

  @Input() width: number;

  @HostBinding('style.width') get _width() {
    return this.width ? this.width + 'px' : this.injectedWidth ? this.injectedWidth + 'px' : '';
  }

  @Input() height: number;

  @HostBinding('style.height') get _height() {
    return this.height ? this.height + 'px' : this.injectedHeight ? this.injectedHeight + 'px' : '';
  }

  @Input() rotation: number;

  @HostBinding('style.transform') get _rotation() {
    return this.rotation ? 'rotate(' + this.rotation + 'deg)' :
      this.injectedRotation ? 'rotate(' + this.injectedRotation + 'deg)' : '';
  }

  // Needed since this component can be dynamically created 
  ngOnDestroy() { }
}
